import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { alpha, useTheme } from '@mui/material/styles';

interface LogTimeRangeProps
{
  setFromTime: (hours: number) => void
  fromTime: number
}

export const LogTimeRange = ({ setFromTime, fromTime }: LogTimeRangeProps) =>
{
  const theme = useTheme()
  return(
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
    <Grid container spacing={1.25}>
      <Grid item>
      <Button sx={styles.button(theme, fromTime === 8)} size="small" onClick={() => setFromTime(8)} variant={fromTime === 8 ?  "contained" : "outlined"}>8 hours</Button>
    </Grid>

    <Grid item>
      <Button sx={styles.button(theme, fromTime === 24)} size="small" onClick={() => setFromTime(24)} variant={fromTime === 24 ?  "contained" : "outlined"}>24 hours</Button>
      </Grid>

     <Grid item>
      <Button sx={styles.button(theme, fromTime === 48)} size="small" onClick={() => setFromTime(48)} variant={fromTime === 48 ?  "contained" : "outlined"}>48 hours</Button>
    </Grid>

      <Grid item>
        <Button sx={styles.button(theme, fromTime === 168)} size="small" onClick={() => setFromTime(168)} variant={fromTime === 168 ?  "contained" : "outlined"}>7 days</Button>
      </Grid>

      <Grid item>
        <Button sx={styles.button(theme, fromTime === 168 * 4)} size="small" onClick={() => setFromTime(168 * 4)}variant={fromTime === 168 * 4 ?  "contained" : "outlined"}>1 month</Button>
      </Grid>

      <Grid item>
        <Button sx={styles.button(theme, fromTime === 168 * 8)} size="small" onClick={() => setFromTime(168 * 8)} variant={fromTime === 168 * 8 ?  "contained" : "outlined"}>2 months</Button>
      </Grid>

      <Grid item>
        <Button sx={styles.button(theme, fromTime === 168 * 26)} size="small" onClick={() => setFromTime(168 * 26)} variant={fromTime === 168 * 26 ?  "contained" : "outlined"}>6 months</Button>
      </Grid>

      <Grid item>
        <Button sx={styles.button(theme, fromTime === 168 * 52)} size="small" onClick={() => setFromTime(168 * 52)} variant={fromTime === 168 * 52 ?  "contained" : "outlined"}>12 months</Button>
      </Grid>

  </Grid>
  </Box>
  )
}

const styles = {
  button: (theme: any, active: boolean) => ({
    minWidth: 108,
    minHeight: 42,
    borderRadius: "12px",
    boxShadow: "none",
    color: active ? theme.palette.common.white : theme.palette.text.primary,
    background: active
      ? `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.info.main})`
      : alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.05 : 0.72),
    borderColor: alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.1 : 0.4),
  }),
}
